import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { connect } from "react-redux";
import { Grid } from "@material-ui/core";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { authLogin } from "../Redux/Actions";
import FormGenerator from "../Components/FormGenerator";
import { useHistory } from "react-router-dom";
import { useSnackbar } from "notistack";
const Login = ({ authLogin }) => {
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const loginField = [
    {
      name: "email",
      type: "text",
      label: "Email",
      field: "text",
      placeholder: "Email",
      validationType: "string",
      validations: [
        {
          type: "required",
          params: ["this field is required"],
        },
        {
          type: "email",
          params: ["Invalid email"],
        },
      ],
      col: 12,
    },
    {
      name: "password",
      type: "password",
      label: "Password",
      field: "text",
      placeholder: "Password",
      validations: [
        {
          type: "required",
          params: ["this field is required"],
        },
      ],
      validationType: "string",
      col: 12,
    },
  ];
  const handleLogin = (value, formik, step, setDisable) => {
    setDisable(true);
    authLogin(value, formik, history, enqueueSnackbar, setDisable);
  };

  return (
    <Container
      maxWidth="sm"
      style={{
        display: "flex",
        flexDirection: "column",
        height: "fit-content",
        border: "1px solid #ccc", // Add border styling
        borderRadius: "8px", // Optional: Add rounded corners
        padding: "7rem 4rem", // Optional: Add padding
        backgroundColor: "#fff",
      }}
    >
      <Grid style={{ marginBottom: 4 }}>
        <Typography variant="h4" gutterBottom>
          <b>Sign In </b>
        </Typography>
        <Typography variant="body1" color={"#798DA3"}>
          You are signing in. Please provide all the required details.
        </Typography>
      </Grid>
      <br />
      <br />
      <br />
      <FormGenerator
        fields={loginField}
        buttonText={"Login"}
        step={0}
        displayCancel={false}
        onSubmit={handleLogin}
      />
    </Container>
  );
};
const mapStateToProps = (state) => ({});
export default connect(mapStateToProps, { authLogin })(Login);
